import { getAttributeValue } from '@alpha-core/platform-ui';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'attributeValue',
    standalone: true,
    pure: false, // copied from async_pipe code. This should be there to cause the `.transform` to be called on every CD cycle
})
export class customCodeAttributePipe implements PipeTransform {
    transform(attributes: any[], key: string) {
        return getAttributeValue(attributes, key);
    }
}
